export default __webpack_public_path__ + "static/media/appleStore.3cc9e6f0.png";